import { render, staticRenderFns } from "./HeadlinePlayoutLayout.vue?vue&type=template&id=512c11af&scoped=true&"
import script from "./HeadlinePlayoutLayout.vue?vue&type=script&lang=js&"
export * from "./HeadlinePlayoutLayout.vue?vue&type=script&lang=js&"
import style0 from "./HeadlinePlayoutLayout.vue?vue&type=style&index=0&id=512c11af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c11af",
  null
  
)

export default component.exports